import { render, staticRenderFns } from "./ExpressionItem.vue?vue&type=template&id=5ee52e1a&scoped=true"
import script from "./ExpressionItem.vue?vue&type=script&lang=js"
export * from "./ExpressionItem.vue?vue&type=script&lang=js"
import style0 from "./ExpressionItem.vue?vue&type=style&index=0&id=5ee52e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee52e1a",
  null
  
)

export default component.exports